import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import Fade from "@mui/material/Fade";

function ScrollTop(props) {
  const { children, window } = props;

  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor",
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16, zIndex: 999 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element,
  window: PropTypes.func,
};

export default function Navbar(props) {
  return (
    <React.Fragment>
      <AppBar
        color="#FFFFFF66"
        sx={{
          pl: 5,
          pr: 5,
          height: 100,
          borderBottomRightRadius: 30,
          borderBottomLeftRadius: 30,
          backgroundColor: "#FFFFFF66",
          boxShadow: "0px 7px 14.7px 0px #00000040",
          backdropFilter: "blur(40.5px)",
        }}
      >
        <Toolbar sx={{ height: "100%" }}>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography variant="h3">Soucient HRMS – Privacy Policy</Typography>
          </Box>
        </Toolbar>
      </AppBar>

      <Box id="back-to-top-anchor" />

      <ScrollTop {...props}>
        <Fab size="small" aria-label="scroll back to top">
          <ArrowUpwardIcon />
        </Fab>
      </ScrollTop>
    </React.Fragment>
  );
}
